export enum Object {
    "contact.object.station" = 1,
    "contact.object.forecast" = 2,
    "contact.object.problem" = 3,
    "contact.object.experience" = 4
}
